var reinitCursor;

ready(function(){

	reinitCursor = function(){
		// -- variables --
		const $cursor = document.querySelector('.cursor__inner');
		const $cursorCircle = document.querySelector('.cursor__inner circle');
		const $cursorPlus = document.querySelector('.cursor__inner .cursor--plus');
		const $hoverables = document.querySelectorAll('a, button');
		const $iframes = document.querySelectorAll('iframe');
		// -- listeners --
		document.body.addEventListener('mousemove', onMouseMove);
		for (let i = 0; i < $hoverables.length; i++) {
		  $hoverables[i].addEventListener('mouseenter', onMouseHover);
		  $hoverables[i].addEventListener('mouseleave', onMouseHoverOut);
		}

		// -- hide custom cursor for iframes --
		for (let i = 0; i < $iframes.length; i++) {
		  $iframes[i].addEventListener('mouseenter', (event) => {
	      document.querySelector('.cursor').classList.remove('sm:block');
		  });
		  $iframes[i].addEventListener('mouseleave', (event) => {
    		document.querySelector('.cursor').classList.add('sm:block');
		  });
		}
	
		// -- move the cursor --
		function onMouseMove(e) {
			// console.log('onMouseMove');
			$cursor.style.top = (e.y - 15) + 'px';
			$cursor.style.left = (e.x - 15) + 'px';
		}

		// -- hover an element --
		function onMouseHover() {
			$cursor.style.transform = 'scale(2)';
			$cursorCircle.style.fill = 'transparent';
			if (this.classList.contains('cursor--plus')) {
				$cursorPlus.classList.remove('opacity-0');
			}
		}

		function onMouseHoverOut() {
			$cursor.style.transform = 'scale(1)';
			$cursorCircle.style.fill = '#E6E6E6';
			$cursorPlus.classList.add('opacity-0');
		}
	}
	reinitCursor();

});